import amazon from './amazon';

const listTemplates = [amazon];

export default listTemplates;
